import {ApplicationEvent} from './application-event.model';
import {ApplicationEventType, ApplicationSearchEventSource} from '../constants';

export class CategoryPageApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.CategoryPage;

  constructor(private categoryName: string,
              private source: ApplicationSearchEventSource,
              private expiredPromoTag?: boolean,
              private hasFilters?: boolean,
              private totalItems?: number,
              private content?: string) {}

  getPayload(): CategoryPageApplicationEventPayload {
    return {
      GA360_query: this.categoryName,
      source: this.source,
      expiredPromoTag: this.expiredPromoTag,
      hasFilters: this.hasFilters,
      GA360_regularResults: this.totalItems,
      label: this.categoryName,
      content: this.content
    };
  }
}

export interface CategoryPageApplicationEventPayload {
  GA360_query: string;
  source: ApplicationSearchEventSource;
  label: string;
  expiredPromoTag?: boolean;
  hasFilters?: boolean;
  GA360_regularResults?: number;
  content?: string;
}
